import { CenterAligned, classNames } from "@opensea/ui-kit"

type Props = {
  className?: string
  size?: number
}

export const AnimatedLogo = ({ className, size = 100 }: Props) => {
  return (
    <CenterAligned
      className={classNames(
        "overflow-hidden rounded-full drop-shadow-sm",
        className,
      )}
      style={{ width: size, height: size }}
    >
      <div className="size-[calc(100%+1px)]">
        <video
          autoPlay
          disableRemotePlayback
          loop
          muted
          playsInline
          preload="auto"
        >
          <source
            src="https://raw.seadn.io/files/os-logo-glowing.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </CenterAligned>
  )
}
